module.exports = __webpack_public_path__ + "static/Ganjar-b8060be84e44e51cf4f2fb3a0488edd1.jpg";